import { render, staticRenderFns } from "./exam-details.vue?vue&type=template&id=188c898f&scoped=true"
import script from "./exam-details.vue?vue&type=script&lang=js"
export * from "./exam-details.vue?vue&type=script&lang=js"
import style0 from "./exam-details.vue?vue&type=style&index=0&id=188c898f&prod&scoped=true&lang=css"
import style1 from "./exam-details.vue?vue&type=style&index=1&id=188c898f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c898f",
  null
  
)

export default component.exports